import { Validate } from "./validate";
import { displayGenericError, displayInputErrorMarkup, serviceNetworkError } from "./failhandler";
import "../utils";

var form = (function () {
    "use strict";

    var main = $('#main'),
        signup = $('.signup'),
        submitBtn = null,
        messageDiv = null,
        errMessage = '';

    // Only add listeners on signup page
    if (signup.length > 0) {
        main.on('click', '.form button[type="submit"]', submitHandler);
    }

    //  Trigger chosen
    $('.chosen').chosen({ disable_search: true });

    // Submit handler
    function submitHandler(e) {
        e.preventDefault();
        var form = $(this).closest('.form'),
            serviceMethod = form.data('form-method'),
            inputs = form.find('.form-item input, .form-item textarea'),
            inputsToValidate = form.find('.form-item input[data-required=true], .form-item textarea[data-required=true]'),
            products = form.find('.form-item input[type="checkbox"]:checked'),
            validated = true,
            request = {},
            data = {},
            cl = new CanvasLoader('loaderForm');

        submitBtn = form.find('input[type="submit"]');
        messageDiv = form.find('.form-message');
        errMessage = form.find('.form-message').data('error-message');
        messageDiv.removeClass("alert-success alert-error error").hide();

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);

        inputsToValidate.each(function () {
            if (!Validate.validate.call($(this))) {
                validated = false;
            }
        });

        if (validated) {

            submitBtn.addClass("loading");
            submitBtn.prop('disabled', true);
            cl.show();

            // Build data object
            inputs.each(function () {
                var $this = $(this),
                    prop = $this.attr('name'),
                    value = $this.val();

                request[prop] = value;
            });

            request["comment"] = form.find('.form-item textarea[name=comment]').val();
            request["products"] = $.map(products, function (n, i) {
                return $(n).val();
            }).join(", ");
            data['request'] = request;

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.signup,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        }

        function doneHandler(response) {

            cl.hide();
            submitBtn.removeClass("loading");
            submitBtn.prop('disabled', false);

            if (response.Success) {

                var category = "Club";
                var label = $("input[name='name']", form).val();

                if ($("input[name='organizationnumber']", form).length === 1) {
                    category = "Shop";
                }

                if ($("input[name='teamname']", form).length === 1) {
                    category = "Team";
                    label = $("input[name='teamname']", form).val();
                }

                Utils.TrackGoogleEvent(category, "CompleteRegistration", label, undefined, response.Data.EventId);

                inputs.each(function () { $(this).val(""); });
                products.each(function () { $(this).prop('checked', false); });
                messageDiv.addClass("alert-success");
                messageDiv.html("<h4 style=\"color:#5197AB;margin:0;\">" + messageDiv.data('successMessage') + "</h4>").show();

            } else {
                messageDiv.addClass("alert-error").show();
                displayGenericError(messageDiv, response);
                displayInputErrorMarkup(form, response);
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            serviceNetworkError(messageDiv);
        }
    }

})();